import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.8746 15.0005L11.9946 11.1205L8.11461 15.0005C7.72461 15.3905 7.09461 15.3905 6.70461 15.0005C6.31461 14.6105 6.31461 13.9805 6.70461 13.5905L11.2946 9.00047C11.6846 8.61047 12.3146 8.61047 12.7046 9.00047L17.2946 13.5905C17.6846 13.9805 17.6846 14.6105 17.2946 15.0005C16.9046 15.3805 16.2646 15.3905 15.8746 15.0005Z",
		fill: "#63688B"
	})
});
export default SvgCaretUp;
